import {
  ANALYTICS_OVERVIEW_REQUEST,
  ANALYTICS_OVERVIEW_SUCCESS,
  ANALYTICS_OVERVIEW_FAILURE,
  ANALYTICS_CHANNELS_REQUEST,
  ANALYTICS_CHANNELS_SUCCESS,
  ANALYTICS_CHANNELS_FAILURE,
  ANALYTICS_USERS_REQUEST,
  ANALYTICS_USERS_SUCCESS,
  ANALYTICS_USERS_FAILURE,
  ANALYTICS_CHANNEL_DETAIL_REQUEST,
  ANALYTICS_CHANNEL_DETAIL_SUCCESS,
  ANALYTICS_CHANNEL_DETAIL_FAILURE,
  ANALYTICS_USER_DETAIL_REQUEST,
  ANALYTICS_USER_DETAIL_SUCCESS,
  ANALYTICS_USER_DETAIL_FAILURE,
} from '../../types';

export interface IAnalyticsState {
  overview: any | null;
  channels: any[] | null;
  users: any[] | null;
  channelDetail: any | null;
  userDetail: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: IAnalyticsState = {
  overview: null,
  channels: null,
  users: null,
  channelDetail: null,
  userDetail: null,
  loading: false,
  error: null,
};

export default function analyticsReducer(
  state = initialState,
  action: any
): IAnalyticsState {
  switch (action.type) {
    case ANALYTICS_OVERVIEW_REQUEST:
      return { ...state, loading: true, error: null };
    case ANALYTICS_OVERVIEW_SUCCESS:
      return { ...state, loading: false, overview: action.payload };
    case ANALYTICS_OVERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ANALYTICS_CHANNELS_REQUEST:
      return { ...state, loading: true, error: null };
    case ANALYTICS_CHANNELS_SUCCESS:
      return { ...state, loading: false, channels: action.payload };
    case ANALYTICS_CHANNELS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ANALYTICS_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case ANALYTICS_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case ANALYTICS_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ANALYTICS_CHANNEL_DETAIL_REQUEST:
      return { ...state, loading: true, error: null };
    case ANALYTICS_CHANNEL_DETAIL_SUCCESS:
      return { ...state, loading: false, channelDetail: action.payload };
    case ANALYTICS_CHANNEL_DETAIL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ANALYTICS_USER_DETAIL_REQUEST:
      return { ...state, loading: true, error: null };
    case ANALYTICS_USER_DETAIL_SUCCESS:
      return { ...state, loading: false, userDetail: action.payload };
    case ANALYTICS_USER_DETAIL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
